var React = require('react');
var STAKE = require('../stake-placement');
var connect = require('react-redux').connect;
var Link = require('react-router').Link;
var CasinoSearchBar = require('../casino-search-bar');
var CasinoSearchArray = require('../casino-search-array');
var SiteFooter = require('../site-footer');
var METRO_HUBS = require('../metro-hubs');
var DayBrowser = require('../day-browser');
var actions = require('../actions');
var encodeSlug = require('../room-slug');
var roomsWithSchedules = require('../rooms-with-schedules');
var roomsIndex = require('../rooms-index');
var roomNames = require('../rooms-to-prerender');

// States without a state hub: link every room so each is one click from home.
var MORE_STATES = roomsIndex.build(roomNames || []).filter(function (group) { return !group.stateHub; });

var HOME_FEATURED_ROOMS = [
  'Commerce Casino',
  'Bellagio Hotel & Casino',
  'Doghouse Poker Club',
  'Texas Card House Houston',
  "Ace's Poker Mountlake Terrace",
  'Seminole Hard Rock Hotel & Casino, Tampa',
  'Sycuan Casino',
  'Wynn, Las Vegas'
].filter(function (name) {
  return (roomsWithSchedules || []).indexOf(name) !== -1;
});

var PAGE_TITLE = 'Daily Tourneys | U.S. Casino & Poker Room Tournament Schedules';

var STATE_LINKS = [
  { to: '/texas-poker-rooms', label: 'Texas' },
  { to: '/california-poker-rooms', label: 'California' },
  { to: '/florida-poker-rooms', label: 'Florida' },
  { to: '/washington-poker-rooms', label: 'Washington' }
];

var HomePage = React.createClass({
  componentDidMount: function () {
    document.title = PAGE_TITLE;
  },

  onAddInput: function (event) {
    var casinos = CasinoSearchArray || [];
    var value = String(event.target.value || '').toLowerCase().trim();
    var tempLib = [];
    if (value.length > 0) {
      tempLib = casinos.filter(function (item) {
        return String(item).toLowerCase().indexOf(value) !== -1;
      });
    }
    this.props.dispatch(actions.addInput(tempLib));
  },

  render: function () {
    var cityLinks = Object.keys(METRO_HUBS).map(function (slug) {
      var hub = METRO_HUBS[slug];
      return (
        <li key={slug}>
          <Link to={'/' + slug}>{hub.shortLabel || hub.footerLabel}</Link>
        </li>
      );
    });

    var stateBits = [];
    STATE_LINKS.forEach(function (item, i) {
      if (i > 0) stateBits.push(<span key={'sep-' + item.to} aria-hidden="true"> · </span>);
      stateBits.push(<Link key={item.to} to={item.to}>{item.label}</Link>);
    });

    var featuredBits = [];
    HOME_FEATURED_ROOMS.forEach(function (name, i) {
      if (i > 0) featuredBits.push(<span key={'fsep-' + name} aria-hidden="true"> · </span>);
      featuredBits.push(
        <Link key={'feat-' + name} to={'/allcasinos/' + encodeSlug(name)}>{name}</Link>
      );
    });

    return (
      <div className="home-page main-container">
        <section className="home-intro" aria-label="About Daily Tourneys">
          <p className="home-intro-lead">
            Search U.S. poker rooms by name or state, or open a city hub for the rooms on file. Buy-ins and start times show up only when a schedule is already in the database.
          </p>
        </section>

        <CasinoSearchBar
          list="allcasinos"
          addInput={this.onAddInput}
          output={this.props.output}
        />

        <div className="home-below">
          <section className="home-cities" aria-label="City hubs">
            <p className="home-section-label">City hubs</p>
            <ul className="home-city-grid">{cityLinks}</ul>
            <p className="home-intro-links">States: {stateBits}</p>
            {featuredBits.length ? (
              <p className="hub-featured-rooms">Rooms with schedules: {featuredBits}</p>
            ) : null}
            <p className="home-intro-links">
              <Link to="/all-poker-rooms">All poker rooms by state</Link>
              <span aria-hidden="true"> · </span>
              <Link to="/guides/how-daily-tournaments-work">How dailies work</Link>
              <span aria-hidden="true"> · </span>
              <Link to="/guides/tournament-terms">Tournament terms</Link>
              <span aria-hidden="true"> · </span>
              <Link to="/guides/poker-tournament-faq">FAQ</Link>
              <span aria-hidden="true"> · </span>
              <Link to="/about">About</Link>
            </p>
            <p className="home-intro-links home-stake-links">
              <Link to={STAKE.guide}>{STAKE.home.guideLabel}</Link>
              <span aria-hidden="true"> · </span>
              <a href={STAKE.go('home')} rel="sponsored nofollow">{STAKE.home.joinLabel}</a>
            </p>
          </section>

          <DayBrowser />

          {MORE_STATES.length ? (
            <section className="home-more-states">
              <h2>Poker rooms in more states</h2>
              <ul>
                {MORE_STATES.map(function (group) {
                  var bits = [];
                  group.rooms.forEach(function (name, i) {
                    if (i > 0) bits.push(<span key={'s' + i} aria-hidden="true"> · </span>);
                    bits.push(<Link key={name} to={'/allcasinos/' + encodeSlug(name)}>{name}</Link>);
                  });
                  var hubBits = [];
                  group.hubs.forEach(function (hub, i) {
                    if (i > 0) hubBits.push(<span key={'hs' + i} aria-hidden="true"> · </span>);
                    hubBits.push(<Link key={hub.to} to={hub.to}>{hub.label}</Link>);
                  });
                  return (
                    <li key={group.state}>
                      <strong>{group.state}</strong>
                      {hubBits.length ? <span> ({hubBits})</span> : null}
                      {': '}{bits}
                    </li>
                  );
                })}
              </ul>
            </section>
          ) : null}

          <SiteFooter />
        </div>
      </div>
    );
  }
});

var mapStateToProps = function (state) {
  return {
    output: state.output || []
  };
};

module.exports = connect(mapStateToProps)(HomePage);



// WEBPACK FOOTER //
// ./js/pages/home-page.jsx